import React from 'react';
import Lessons from '../lessons';

function LessonsPage() {
    return (
        <Lessons />
    )
}

export default LessonsPage;